export type ApprovalClickableVariables =
  | 'customerSignedDate'
  | 'companySignedDate'
  | 'customerSignature'
  | 'companySignature';

export const getApprovalInfoKeyByCellIdentifier = (cellContent: string) => {
  switch (cellContent) {
    case 'SIGNATURE_CUSTOMER':
      return 'customerSignature';
    case 'DATE_CUSTOMER':
      return 'customerSignedDate';
    case 'DATE_COMPANY':
      return 'companySignedDate';
    case 'SIGNATURE_COMPANY':
      return 'companySignature';
    default:
      return '';
  }
};

export type AlignmentType = 'left' | 'center' | 'right';

export const getCellIdentifierByApprovalVariable = (approvalVariable: ApprovalClickableVariables) => {
  if (approvalVariable.includes('customer')) {
    return {
      signature: 'SIGNATURE_CUSTOMER',
      date: 'DATE_CUSTOMER',
    };
  } else if (approvalVariable.includes('company')) {
    return {
      signature: 'SIGNATURE_COMPANY',
      date: 'DATE_COMPANY',
    };
  }
  return {};
};
